class NewsletterModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['modal', 'close', 'backdrop', 'country-code', 'number', 'phone']
  }

  constructor () {
    super()

    const isTestMode =
      this.dataset.testMode === 'true' && window.Shopify.designMode

    if (!this.noLocalStorageSet && !isTestMode) return

    let timeout = Number.parseInt(this.dataset.showModal)

    if (isTestMode) {
      timeout = 0
    }

    this.onLoad = this.onLoad.bind(this)
    window.setTimeout(this.onLoad, timeout)
  }

  setupListeners () {
    super.setupListeners()

    this.onCloseClick = this.onCloseClick.bind(this)
    this.onEscapePress = this.onEscapePress.bind(this)
    this.onPhoneInput = window.BAO.Utils.debounce(
      this.onPhoneInput.bind(this),
      300,
    )

    this.listeners.add(this.els.close.element, 'click', this.onCloseClick)
    this.listeners.add(this.els.backdrop.element, 'click', this.onCloseClick)
    this.listeners.add(document, 'keyup', this.onEscapePress)
    this.listeners.add(this.els.number.element, 'input', this.onPhoneInput)
  }

  onLoad () {
    this.detectCountryCode()

    this.els.modal.element.setAttribute('data-hidden', false)

    if (this.modalState) {
      document.body.classList.add('util-SiteOverflowed')
    }
  }

  detectCountryCode () {
    const countryCodeSelect = this.els['country-code'].element
    const defaultCountry = window.Shopify.country
    const countryCallingCodes = {
      GB: '+44',
      US: '+1',
      CA: '+1',
      JP: '+81',
      IE: '+353',
      AU: '+61',
      NZ: '+64',
      FR: '+33',
      DE: '+49',
      IT: '+39',
      ES: '+34',
      CN: '+86',
      HK: '+852',
      SG: '+65',
      KR: '+82',
      NL: '+31',
      BE: '+32',
      DK: '+45',
      SE: '+46',
      NO: '+47',
      FI: '+358',
      CH: '+41',
      AT: '+43',
      PT: '+351',
      PL: '+48',
      AE: '+971',
    }

    window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    })
      .then(res => {
        if (res?.detected_values?.country?.handle) {
          // Get the country code from Shopify's response
          const countryCode = res.detected_values.country.handle.toUpperCase()

          // Get the calling code for the detected country or fall back to store's country
          const callingCode =
            countryCallingCodes[countryCode] ||
            countryCallingCodes[defaultCountry]

          if (callingCode) {
            countryCodeSelect.value = callingCode
          } else {
            // If store's country isn't in our mapping, default to first option in select
            countryCodeSelect.value = countryCodeSelect.options[0].value
          }
        }
      })
      .catch(error => {
        console.warn('Failed to detect country code:', error)
        // Fall back to store's country code
        const storeCallingCode = countryCallingCodes[defaultCountry]
        countryCodeSelect.value =
          storeCallingCode || countryCodeSelect.options[0].value
      })
  }

  onCloseClick () {
    this.els.modal.element.setAttribute('data-hidden', true)

    if (this.modalState) {
      document.body.classList.remove('util-SiteOverflowed')
    }

    this.onClose()
  }

  onEscapePress (event) {
    if (event.key === 'Escape') {
      this.els.modal.element.setAttribute('data-hidden', true)

      if (this.modalState) {
        document.body.classList.remove('util-SiteOverflowed')
      }

      this.onClose()
    }
  }

  onClose () {
    window.localStorage.setItem(this.localStorageName, 'true')
  }

  timeout () {}

  get modalState () {
    return this.els.modal.element.getAttribute('data-hidden')
  }

  get noLocalStorageSet () {
    return (
      window.localStorage.getItem(this.localStorageName) === undefined ||
      window.localStorage.getItem(this.localStorageName) === null
    )
  }

  get localStorageName () {
    return 'Sunspel-newsletter'
  }

  cleanPhoneNumber (number) {
    return number.replace(/[^0-9]/g, '')
  }

  validateAndFormatPhoneNumber (phoneNumber) {
    // Remove any non-digit characters except + at the start
    const cleanNumber = phoneNumber.replace(/(?!^\+)[^0-9]/g, '')

    // Basic validation: should have between 8 and 15 digits after country code
    const digitCount = cleanNumber.replace(/^\+/, '').length
    return digitCount >= 8 && digitCount <= 15 ? cleanNumber : false
  }

  handleSmsOptinFields (form, shouldAdd) {
    const fields = [
      { name: '@sms_optin_checkbox', value: 'true' },
      { name: 'sms_optin', value: 'true' },
    ]

    for (const { name } of fields) {
      const existingField = form.querySelector(`input[name="${name}"]`)
      if (shouldAdd && !existingField) {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = 'true'
        form.appendChild(input)
      } else if (!shouldAdd && existingField) {
        existingField.remove()
      }
    }
  }

  onPhoneInput () {
    const countryCode = this.els['country-code'].element.value
    const phoneNumber = this.els.number.element.value

    // Clean the number (remove any non-digits)
    const cleanNumber = this.cleanPhoneNumber(phoneNumber)

    // Format and validate the full number
    const formattedNumber = `${countryCode}${cleanNumber}`
    const isValid = this.validateAndFormatPhoneNumber(formattedNumber)

    if (isValid) {
      // Store the formatted number (with country code) in the hidden input
      this.els.phone.element.value = formattedNumber
      this.els.number.element.setCustomValidity('')
      this.handleSmsOptinFields(this.els.number.element.form, true)
    } else {
      // Clear the hidden input if invalid
      this.els.phone.element.value = ''
      this.els.number.element.setCustomValidity(
        window.theme?.strings?.validPhoneNumber ||
          'Please enter a valid phone number',
      )
      this.handleSmsOptinFields(this.els.number.element.form, false)
    }

    this.els.number.element.reportValidity()
  }
}

if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', NewsletterModal)
}
